'use strict';
import angular from 'angular';
import contentLinksHtmlUrl from './views/contentLinks.html';
import _ from "lodash";

var app = angular.module('app.contentLinks', []);

app.component('contentLinks', {
    bindings: {
        contentLinks: '=',
        modelValue : '=',
        showActions : '=',
        form : '<'
    },
    templateUrl: contentLinksHtmlUrl,

    controller: function($scope, $ioAlert, FormService) {
        var self = this;
        self.dataObj = null;
        self.showButtons = false;
        self.initialCTALink = null;
        self.initialUnsubLink = null;
        self.mainTaggedLink = null;

        $scope.$watch('$ctrl.dataObj.cta_link', function(selectedVal) {
            showButtonIfRequired(selectedVal, self.dataObj?.unsub_link);
            if (!selectedVal && self.dataObj) {
                self.dataObj.cta_link = null;
            }
        });

        $scope.$watch('$ctrl.dataObj.unsub_link', function(selectedVal) {
            showButtonIfRequired(self.dataObj?.cta_link, selectedVal);
            if (!selectedVal && self.dataObj) {
                self.dataObj.unsub_link = null;
            }
        });

        self.filterUnsub = function(link) {
            return link.url != '{{CUSTOM_URL}}';
        };

        self.toggleShowUnsub = function() {
            showButtonIfRequired(self.dataObj?.cta_link, self.dataObj?.unsub_link);
        };

        function showButtonIfRequired(ctaLink, unsubLink) {
            if (!unsubLink) {
                unsubLink = null; // in case it was undefined
            }
            self.showButtons = (ctaLink && ((ctaLink != self.initialCTALink) ||
                (self.contentLinks.showUnsub && (self.initialUnsubLink != unsubLink)) ||
                (!self.contentLinks.showUnsub && self.initialUnsubLink))
            );
        }

        self.saveContentLinks = function() {
            harvestContentLinks();
            self.showButtons = false;

            FormService.setContentLinks(self.contentLinks).then(function(response) {
                if (response.data.status == 'success') {
                    $ioAlert.show('Success!', response.data.message, 'success');
                } else {
                    $ioAlert.show('Error!', 'An error occurred: ' + response.data.message, 'error');
                }
            }, function() {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        };

        function harvestContentLinks() {
            clearContentLinks();

            if (self.contentLinks?.links) {
                let ctaLinkObj = _.find(self.contentLinks.links, {index: self.dataObj.cta_link.index});
                if (ctaLinkObj) {
                    ctaLinkObj.is_main_cta = 1;
                }

                if (self.contentLinks.showUnsub && self.dataObj.unsub_link) {
                    let unsubLinkObj = _.find(self.contentLinks.links, {index: self.dataObj.unsub_link.index});
                    if (unsubLinkObj) {
                        unsubLinkObj.is_unsub = 1;
                    }
                }
            }
        }

        function clearContentLinks() {
            if (self.contentLinks?.links) {
                _.each(self.contentLinks?.links, function (link) {
                    link.is_main_cta = 0;
                    link.is_unsub = 0;
                });
            }
        }

        function newDataObj() {
            let dataObj = {};
            dataObj.ctaLinkIndex = null;
            dataObj.unsubLinkIndex = null;
            return dataObj;
        }

        self.initComponent = function() {
            self.preHtmlValidationMode = true;
            let mainTaggedLink = null;
            if (self.contentLinks) {
                self.dataObj = newDataObj();
                self.contentLinks = JSON.parse(self.contentLinks);

                if (self.contentLinks?.links) {
                    _.each(self.contentLinks?.links, function (link) {
                        if (link.is_main_cta == 1) {
                            self.initialCTALink = link;
                            self.dataObj.cta_link = link;
                        }

                        if (link.is_unsub == 1) {
                            self.initialUnsubLink = link;
                            self.dataObj.unsub_link = link;
                        }

                        if (link.tag == 'main') {
                            mainTaggedLink = link;
                        }
                        self.preHtmlValidationMode = false;
                    });
                }
                if (!self.contentLinks?.showUnsub) {
                    self.contentLinks.showUnsub = false;
                }

                if (!self.initialCTALink && mainTaggedLink) {
                    self.dataObj.cta_link = mainTaggedLink;
                    self.showButtons = true;
                }
            } else {
                // Initialize object (e.g. at flight/line creation).
                self.contentLinks = {};
                self.contentLinks.showUnsub = false;
            }
        };

        self.initComponent();

        $scope.$watch('$viewContentLoaded', 
            function() { 
                var selectList = angular.element('[name="__has_unsubscribe_link"]');
    
                selectList.on('change', function () {
                    $scope.$apply(function () {
                        if (selectList.length > 0) {
                            if (selectList[0].value == 'string:Yes') {
                                self.contentLinks.showUnsub = true;
                            } else if (selectList[0].value == 'string:No') {
                                self.contentLinks.showUnsub = false;
                            }
                        }
                    });
                });
        });
    }
});